import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class RevenueTypeEditService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }


	loadRevenueType(token, ID) {

		return this.http
		.get(this.apiUrl + "revenue/v1/getcodrevenue/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});

	}


	editRevenueType(token, revenueType: any) {

		return this.http
		.put(this.apiUrl + "revenue/v1/updaterevenue", revenueType, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/revenue-type/service/revenue-type-edit/revenue-type-edit.service.ts